import * as ConsentService from "@/services/consent/consent.service";
import { initializeAnalyticsInteractions } from "@/services/tracking";

import EventDataLayer from "./queue/EventDataLayer";
import { AidenSubscriber } from "./subscribers/aiden/AidenSubscriber";
import {
    AlgoliaConsent,
    AlgoliaSubscriber
} from "./subscribers/algolia/AlgoliaSubscriber";
import {
    BazaarvoiceConsent,
    BazaarvoiceSubscriber
} from "./subscribers/bazaarVoice/BazaarvoiceSubscriber";
import { DebugSubscriber } from "./subscribers/debugger/DebugSubscriber";
import { GoogleAnalyticsSubscriber } from "./subscribers/googleanalytics/GoogleAnalyticsSubscriber";

const initConsent = async () => {
    return Promise.all([AlgoliaConsent(), BazaarvoiceConsent()]);
};

const subscribe = (withHistory = false) => {
    const eventDataLayer = EventDataLayer.getInstance();

    eventDataLayer.clear();

    GoogleAnalyticsSubscriber(eventDataLayer, withHistory);
    DebugSubscriber(eventDataLayer, withHistory);
    AidenSubscriber(eventDataLayer, withHistory);
    BazaarvoiceSubscriber(eventDataLayer, withHistory);
    AlgoliaSubscriber(eventDataLayer, withHistory);
};

const initializeAnalytics = async () => {
    // Ensure an instance
    const eventDataLayer = EventDataLayer.getInstance();
    initializeAnalyticsInteractions();

    await initConsent();

    if (!(await ConsentService.isOnlyStrictCookiesEnabled())) {
        subscribe(true);
    } else {
        eventDataLayer.clear();
    }

    ConsentService.handleOnConsentChanged(async () => {
        await initConsent();

        if (!(await ConsentService.isOnlyStrictCookiesEnabled())) {
            subscribe(true);
        } else {
            eventDataLayer.clear();
        }
    });
};

export { initializeAnalytics };
